<template>
  <input
    ref="inputRef"
    type="text" 
    class="currency-input"
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: Number, // Vue 2: value
    options: Object
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options)

    return { inputRef }
  }
}
</script>
<style scoped>
.currency-input {
  height: 30px; /* Aumenta el alto del input */
  padding: 0px 0px; /* Añade padding interno */
  padding-right: 6px;
  font-size: 16px; /* Tamaño de fuente */
  border: 1px solid #ccc; /* Borde gris claro */
  border-radius: 4px; /* Bordes redondeados */
  width: 100%; /* Ancho completo del contenedor */
  outline: none; /* Quita el outline al hacer focus */
}

.currency-input:focus {
  border-color: #4a90e2; /* Cambia el color del borde al hacer focus */
  box-shadow: 0 0 5px rgba(74, 144, 226, 0.3); /* Añade un sutil sombreado al hacer focus */
}
</style>